export default __webpack_public_path__ + "static/media/use_action_xw.014b4a0f.png";